<template>
  <div id="app" @error="showModalError">
    <ModalError ok-only title="Error"></ModalError>
    <alert-success v-model="showSuccess">{{ successMessage }}</alert-success>
    <Navigation></Navigation>
    <div v-if="user" class="p-2" style="position: absolute; right: 0; color: lightgray; font-size: 14px">
      {{ user.email }}
    </div>
    <div>
      <router-view>
      </router-view>
    </div>
  </div>
</template>

<style>

h4 {
  margin-top: 2% !important;
}

.container {
  padding: 2%;
}

.card {
  margin: 2% 0;
}

.from-group {
  margin-bottom: 2% !important;
}

small {
  color: gray;
  font-size: 12px;
}

.custom-file {
  width: fit-content !important;
  margin-right: 5%;
  top: -2px;
}

.card-img-left {
  height: fit-content;
  width: 25%;
  margin: auto;
}

.navbar button {
  background: none;
  border: none;
  padding: 5px;
}

.navbar button.active {
  background: lightgray;
}

.textarea {
  border: 1px solid lightgray;
  border-radius: 4px;
}

.table th {
  border-top: 0px !important;
}

.router-link-active {
  text-decoration: underline;
}

</style>

<script>
import firebase from "firebase";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import AlertSuccess from "@/components/AlertSuccess"
import platformSettings from '~config/settings'
import {FeatureToggleComponent as feature} from 'vue-feature-toggle';
import * as Sentry from "@sentry/vue";
import Navigation from "@/components/Navigation";
import ModalError from "@/components/ModalError";

platformSettings.features.forEach(featureName => feature.visibility(featureName, true))

export default {
  components: {AlertSuccess, Navigation, ModalError},
  provide() {
    return {
      showSuccessAlert: this.showSuccessAlert,
    }
  },
  data() {
    return {
      user: null,
      shopUrl: platformSettings.shopUrl,
      showSuccess: false,
      successMessage: "All good",
      errorState: {
        message: '',
        visible: false
      },
    }
  },
  async created() {
    try {
      firebase.auth().onAuthStateChanged(async user => {
        if (user) {
          this.$store.commit('user/setUser', user)
          Sentry.setUser({
            email: user.email,
            id: user.uid
          })
          await this.$store.dispatch('user/fetchUserProfile')
        }
      })
    } catch (error) {

      this.$bvModal.show('error-modal')
    } finally {
      this.$store.commit('user/setFetched', true)
    }
  },
  methods: {
    showSuccessAlert(message) {
      this.showSuccess = 3
      this.successMessage = message
    },
    showModalError(event) {
      this.errorState.visible = true;
      this.errorState.message = event.payload[0];
    },
    handleError(error) {
      console.log(error);
      this.$bvModal.show('error-modal')
    }
  }
}
</script>

<style>
/* workaround for incomplete css loaded by vue */
@import 'https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css';
@import 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-vue/2.21.2/bootstrap-vue.min.css';
</style>
